module.exports = __webpack_public_path__ + "img/music.27b5b5de.svg";